<template>
    <div
        id="lt-yantr-v2"
        class="advanced-calc home-affordability-calc-v2"
        :class="{ index: hasHeader || hasSubheader}">
        <h2
            v-if="hasHeader"
            class="green-header">
            {{ header }}
        </h2>
        <h1
            v-if="hasSubheader"
            class="text-center">
            {{ subheader }}
        </h1>
        <div
            v-if="myltexp == 1"
            class="container-width">
            <!-- myltexp v2 -->
            <div class="home-affordability-v2">
                <div class="filter-inputs">
                    <div>
                        <number-input
                            id="AnnualIncome"
                            v-model="AnnualIncome"
                            :label="labelAnnualIncome"
                            :tooltip-link="AnnualIncomeTooltip"
                            :show-tooltip-loader="showTooltipLoader"
                            inputmode="decimal"
                        />
                    </div>
                    <div>
                        <number-input
                            id="MonthlyExpenses"
                            v-model="MonthlyExpenses"
                            :label="labelMonthlyExpenses"
                            :tooltip-link="MonthlyExpensesTooltip"
                            :show-tooltip-loader="showTooltipLoader"
                            inputmode="decimal"
                        />
                    </div>
                    <div>
                        <div class="inputs-subtext">
                            <number-input
                                id="DownPayment"
                                v-model="DownPayment"
                                :label="labelDownPayment"
                                :tooltip-link="DownPaymentTooltip"
                                :show-tooltip-loader="showTooltipLoader"
                                inputmode="decimal"
                                max-value="999999999"
                                max-value2="99"
                                symbol-left="$"
                                symbol-right="%"
                            />
                            <span class="subtext-val">{{ DownpaymentPercentage }}%</span>
                        </div>
                    </div>
                    <div>
                        <drop-down
                            id="LoanTermInYears"
                            v-model="LoanTermInYears"
                            :label="labelLoanTerm"
                            :options="LoanTermInYearsList"
                            :tooltip-link="LoanTypeTooltip"
                            :show-tooltip-loader="showTooltipLoader"
                        />
                    </div>
                </div>
                <!-- Advanced Options start -->
                <transition name="slide">
                    <div
                        v-show="ShowAdvancedOptions"
                        class="advanced-options">
                        <div class="filter-inputs">
                            <div>
                                <number-input
                                    id="MortgageRate"
                                    v-model="MortgageRate"
                                    :label="labelMortgageRate"
                                    :precision="3"
                                    symbol="%"
                                    max-value="100.000"
                                    inputmode="decimal"
                                />
                            </div>
                            <div class="inputs-subtext">
                                <number-input
                                    id="HomeInsurance"
                                    v-model="HomeInsurance"
                                    :label="labelHomeInsurance"
                                    inputmode="decimal"
                                />
                            </div>
                            <div class="inputs-subtext">
                                <div class="percentage-input">
                                    <number-input
                                        id="PropertyTaxes"
                                        v-model="PropertyTaxes"
                                        :label="labelPropertyTaxes"
                                        symbol="%"
                                        symbol-aligned="left"
                                        max-value="100.00"
                                        precision="2"
                                        inputmode="decimal"
                                        @input="calculatePropertyvalue"
                                    />
                                </div>
                            </div>
                            <div class="inputs-subtext">
                                <number-input
                                    id="HoaFees"
                                    v-model="HoaFees"
                                    :label="labelMonthlyHoaFees"
                                    inputmode="decimal"
                                    maxlength="6"
                                />
                            </div>
                        </div>
                        <div class="controls">
                            <div class="include-pmi">
                                <div class="form-checkbox">
                                    <input
                                        id="includePMI"
                                        v-model="IsPmiInclude"
                                        type="checkbox"
                                    />
                                    <label for="includePMI"> Include PMI</label>
                                    <lt-label
                                        :span="span"
                                        :tooltip-link="PrivateMortgageInsuranceTooltip"
                                        :show-tooltip-loader="showTooltipLoader"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <!-- Advanced Options end-->
                <div class="controls">
                    <button
                        type="button"
                        class="show-hide-options"
                        @click="viewMoreClick()">
                        <span
                            class="lt-icons"
                            :class="{ 'lt4-MinusCircle': ShowAdvancedOptions, 'lt4-PlusCircle' : !ShowAdvancedOptions}"></span>
                        <span class="hidden-mob">
                            {{ ShowAdvancedOptions ? "Hide" : "Show" }}
                            Advanced Options
                        </span>
                        <span
                            v-if="!ShowAdvancedOptions"
                            class="visible-mob">Advanced</span>
                        <span
                            v-else
                            class="visible-mob">Hide Advanced Options</span>
                    </button>
                    <div>
                        <a
                            href="javascript:void(0)"
                            class="reset-calc"
                            @click="resetFilters()"><span class="lt-icons lt4-Refresh"></span>
                            <span class="hidden-mob">Reset Calculator</span>
                            <span class="visible-mob">Reset</span>
                        </a>
                    </div>
                </div>

                <div class="house-worth text-center">
                    <div class="line"></div>
                    <div class="cta-block">
                        <div class="cta-label-desktop">
                            You can afford a house worth
                        </div>
                        <div class="cta-label-mobile">
                            You can afford
                        </div>
                        <div class="home-price">
                            ${{ currencyFilter(CalculatedValues.homeprice) }}
                        </div>
                    </div>
                </div>

                <div class="calculation-section-v2">
                    <div class="left-section">
                        <h3>Adjust your price range</h3>
                        <p>See how your budget changes based on your affordability range</p>
                        <div class="house-image">
                            <transition name="fade">
                                <img
                                    v-if="percent < 20"
                                    src="../../assets/images/house1.svg"
                                    alt="Conservative home affordability range - small house"
                                />
                            </transition>
                            <transition name="fade">
                                <img
                                    v-if="percent >= 20 && percent < 40"
                                    src="../../assets/images/house2.svg"
                                    alt="Low-moderate home affordability range - medium house"
                                />
                            </transition>
                            <transition name="fade">
                                <img
                                    v-if="percent >= 40 && percent < 60"
                                    src="../../assets/images/house3.svg"
                                    alt="Moderate home affordability range - larger house"
                                />
                            </transition>
                            <transition name="fade">
                                <img
                                    v-if="percent >= 60 && percent < 80"
                                    src="../../assets/images/house4.svg"
                                    alt="High home affordability range - large house"
                                />
                            </transition>
                            <transition name="fade">
                                <img
                                    v-if="percent >= 80"
                                    src="../../assets/images/house5.svg"
                                    alt="Aggressive home affordability range - luxury house"
                                />
                            </transition>
                        </div>
                        <!-- Range Slider start-->
                        <div class="slider-parent">
                            <vue-slider
                                ref="vueSlider"
                                v-model="slider.value"
                                :bg-style="slider.bgStyle"
                                :clickable="slider.clickable"
                                :dot-size="slider.dotSize"
                                :height="slider.height"
                                :max="slider.max"
                                :min="slider.min"
                                :process-style="slider.processStyle"
                                :slider-style="slider.sliderStyle"
                                :tooltip="slider.tooltip"
                                @callback="handleSliderChange($event);"
                            />
                            <div class="range-label">
                                <div class="text-left">
                                    <label>Conservative</label>
                                </div>
                                <div class="text-right">
                                    <label>Aggressive</label>
                                </div>
                            </div>
                        </div>
                        <!-- Range Slider end-->
                        <label
                            v-show="HomePriceMsg"
                            class="DTI-exceeded">Your current Debt to income ratio has already exceeded {{ DebtToIncome }}%</label>
                        <div class="calc-box">
                            <div class="calc-box-section">
                                <h3 class="value">
                                    ${{ currencyFilter(CalculatedValues.homeprice) }}
                                </h3>
                                <label>Home Price</label>
                            </div>
                            <div class="calc-box-section">
                                <h3 class="value">
                                    ${{ currencyFilter(CalculatedPayment) }}
                                </h3>
                                <label>Monthly Payment</label>
                            </div>
                            <div class="calc-box-section">
                                <h3
                                    ref="debtRatio"
                                    class="value">
                                    {{ DebtToIncome }}% <lt-label
                                        :span="span"
                                        :tooltip-link="DebtToIncomeRatioDtiTooltip"
                                        :show-tooltip-loader="showTooltipLoader"
                                    />
                                </h3>
                                <label>Debt to Income</label>
                            </div>
                        </div>
                        <lt-logo v-if="ltLogo==1">
                            <small>NMLS#1136 Terms & Conditions Apply</small>
                        </lt-logo>
                    </div>
                    <div class="right-section text-center">
                        <h3>Monthly budget breakdown</h3>
                        <p>Detailed view of your ${{ currencyFilter(CalculatedValues.income) }} monthly budget</p>
                        <div class="chart-parent">
                            <doughnut-chart
                                ref="doughnutChart"
                                type="RoundedDoughnut"
                                :chart-data="chartData"
                                :options="options"
                                :width="chartWidth"
                                :height="chartHeight"
                            />
                        </div>
                        <ul class="list-unstyled summary-block">
                            <li>
                                <label><span class="green-bg"></span>Mortgage Payment</label>
                                <span class="value">${{ currencyFilter(CalculatedPayment) }}</span>
                            </li>
                            <li>
                                <label><span class="deep-verde-bg"></span>Debt Payments</label>
                                <span class="value">${{ currencyFilter(CalculatedValues.debts) }}</span>
                            </li>
                            <li>
                                <label><span class="blue-bg"></span>Income Taxes</label>
                                <span class="value">${{ currencyFilter(CalculatedValues.taxes) }}</span>
                            </li>
                            <li>
                                <label><span class="purple-bg"></span>Left Over</label>
                                <span class="value">${{ currencyFilter(CalculatedValues.leftover) }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="disclosure-text">
                    <advertising-disclosures
                        :disclosure-id="DisclosureId"
                        :disclosure-text="DisclosureText"
                        :disclosure-tokens="DisclosureTokens"
                    />
                </div>
            </div>
        </div>
        <!-- myltexp v2 -->
        <div
            v-else-if="myltexp == 2"
            class="container-width mylt-dashboard-calculator">
            <div class="home-affordability-v2">
                <div class="filter-inputs">
                    <div>
                        <number-input
                            id="AnnualIncome"
                            v-model="AnnualIncome"
                            :label="labelAnnualIncome"
                            :tooltip-link="AnnualIncomeTooltip"
                            :show-tooltip-loader="showTooltipLoader"
                            inputmode="decimal"
                        />
                    </div>
                    <div>
                        <number-input
                            id="MonthlyExpenses"
                            v-model="MonthlyExpenses"
                            :label="labelMonthlyExpenses"
                            :tooltip-link="MonthlyExpensesTooltip"
                            :show-tooltip-loader="showTooltipLoader"
                            inputmode="decimal"
                        />
                    </div>
                    <div>
                        <div class="inputs-subtext">
                            <number-input
                                id="DownPayment"
                                v-model="DownPayment"
                                :label="labelDownPayment"
                                :tooltip-link="DownPaymentTooltip"
                                :show-tooltip-loader="showTooltipLoader"
                                inputmode="decimal"
                                max-value="999999999"
                                max-value2="99"
                                symbol-left="$"
                                symbol-right="%"
                            />
                            <span class="subtext-val">{{ DownpaymentPercentage }}%</span>
                        </div>
                    </div>
                    <div>
                        <drop-down
                            id="LoanTermInYears"
                            v-model="LoanTermInYears"
                            :label="labelLoanTerm"
                            :options="LoanTermInYearsList"
                            :tooltip-link="LoanTypeTooltip"
                            :show-tooltip-loader="showTooltipLoader"
                        />
                    </div>
                </div>
                <div class="calculation-section-v2">
                    <div class="left-section">
                        <p>See how your budget changes based on your affordability range</p>
                        <div class="house-image">
                            <transition name="fade">
                                <img
                                    v-if="percent < 20"
                                    src="../../assets/images/house1.svg"
                                    alt="Conservative home affordability range - small house"
                                />
                            </transition>
                            <transition name="fade">
                                <img
                                    v-if="percent >= 20 && percent < 40"
                                    src="../../assets/images/house2.svg"
                                    alt="Low-moderate home affordability range - medium house"
                                />
                            </transition>
                            <transition name="fade">
                                <img
                                    v-if="percent >= 40 && percent < 60"
                                    src="../../assets/images/house3.svg"
                                    alt="Moderate home affordability range - larger house"
                                />
                            </transition>
                            <transition name="fade">
                                <img
                                    v-if="percent >= 60 && percent < 80"
                                    src="../../assets/images/house4.svg"
                                    alt="High home affordability range - large house"
                                />
                            </transition>
                            <transition name="fade">
                                <img
                                    v-if="percent >= 80"
                                    src="../../assets/images/house5.svg"
                                    alt="Aggressive home affordability range - luxury house"
                                />
                            </transition>
                        </div>
                        <!-- Range Slider start-->
                        <div class="slider-parent">
                            <vue-slider
                                ref="vueSlider"
                                v-model="slider.value"
                                :bg-style="slider.bgStyle"
                                :clickable="slider.clickable"
                                :dot-size="slider.dotSize"
                                :height="slider.height"
                                :max="slider.max"
                                :min="slider.min"
                                :process-style="slider.processStyle"
                                :slider-style="slider.sliderStyle"
                                :tooltip="slider.tooltip"
                                @callback="handleSliderChange($event);"
                            />
                            <div class="range-label">
                                <div class="text-left">
                                    <label>Conservative</label>
                                </div>
                                <div class="text-right">
                                    <label>Aggressive</label>
                                </div>
                            </div>
                        </div>
                        <!-- Range Slider end-->
                        <label
                            v-show="HomePriceMsg"
                            class="DTI-exceeded">Your current Debt to income ratio has already exceeded {{ DebtToIncome }}%</label>
                        <div class="calc-box">
                            <div class="calc-box-section">
                                <h3 class="value">
                                    ${{ currencyFilter(CalculatedValues.homeprice) }}
                                </h3>
                                <label>Home Price</label>
                            </div>
                            <div class="calc-box-section">
                                <h3 class="value">
                                    ${{ currencyFilter(CalculatedPayment) }}
                                </h3>
                                <label>Monthly Payment</label>
                            </div>
                            <div class="calc-box-section">
                                <h3
                                    ref="debtRatio"
                                    class="value">
                                    {{ DebtToIncome }}% <lt-label
                                        :span="span"
                                        :tooltip-link="DebtToIncomeRatioDtiTooltip"
                                        :show-tooltip-loader="showTooltipLoader"
                                    />
                                </h3>
                                <label>Debt to Income</label>
                            </div>
                        </div>
                        <lt-logo v-if="ltLogo==1">
                            <small>NMLS#1136 Terms & Conditions Apply</small>
                        </lt-logo>
                    </div>
                    <div
                        v-show="false"
                        class="right-section text-center">
                        <doughnut-chart
                            ref="doughnutChart"
                            type="RoundedDoughnut"
                            :chart-data="chartData"
                            :options="options"
                            :width="chartWidth"
                            :height="chartHeight"
                        />
                    </div>
                </div>
                <div class="disclosure-text">
                    <advertising-disclosures
                        :disclosure-id="DisclosureId"
                        :disclosure-text="DisclosureText"
                        :disclosure-tokens="DisclosureTokens"
                    />
                </div>
            </div>
        </div>
        <div
            v-else
            class="container-width">
            <div class="advanced-calc-filter">
                <div class="filter-inputs">
                    <div>
                        <number-input
                            v-model="AnnualIncome"
                            :label="labelAnnualIncome"
                            :tooltip-link="AnnualIncomeTooltip"
                            inputmode="decimal"
                        />
                    </div>
                    <div>
                        <number-input
                            v-model="MonthlyExpenses"
                            :label="labelMonthlyExpenses"
                            :tooltip-link="MonthlyExpensesTooltip"
                            inputmode="decimal"
                        />
                    </div>
                    <div>
                        <div class="inputs-subtext">
                            <number-input
                                v-model="DownPayment"
                                :label="labelDownPayment"
                                :tooltip-link="DownPaymentTooltip"
                                inputmode="decimal"
                                max-value="999999999"
                                max-value2="99"
                                symbol-left="$"
                                symbol-right="%"
                            />
                            <span class="subtext-val">{{ DownpaymentPercentage }}%</span>
                        </div>
                    </div>
                    <div>
                        <drop-down
                            v-model="LoanTermInYears"
                            :label="labelLoanTerm"
                            :options="LoanTermInYearsList"
                            :tooltip-link="LoanTypeTooltip"
                        />
                    </div>
                </div>
                <!-- Advanced Options start -->
                <transition name="slide">
                    <div
                        v-show="ShowAdvancedOptions"
                        class="advanced-options">
                        <div class="filter-inputs">
                            <div>
                                <number-input
                                    v-model="MortgageRate"
                                    :label="labelMortgageRate"
                                    :precision="3"
                                    symbol="%"
                                    max-value="100.000"
                                    inputmode="decimal"
                                />
                            </div>
                            <div class="inputs-subtext">
                                <number-input
                                    v-model="HomeInsurance"
                                    :label="labelHomeInsurance"
                                    inputmode="decimal"
                                />
                                <span class="subtext-val">/yr</span>
                            </div>
                            <div class="inputs-subtext">
                                <div class="percentage-input">
                                    <number-input
                                        v-model="PropertyTaxes"
                                        :label="labelPropertyTaxes"
                                        symbol="%"
                                        symbol-aligned="left"
                                        max-value="100.00"
                                        precision="2"
                                        inputmode="decimal"
                                        @input="calculatePropertyvalue"
                                    />
                                    <span class="subtext-val">${{ PropertyTaxesVal }}/yr</span>
                                </div>
                            </div>
                            <div class="inputs-subtext">
                                <number-input
                                    v-model="HoaFees"
                                    :label="labelHoaFees"
                                    inputmode="decimal"
                                    maxlength="6"
                                />
                                <span class="subtext-val">/mo</span>
                            </div>
                        </div>
                        <div class="controls">
                            <div class="include-pmi">
                                <div class="form-checkbox">
                                    <input
                                        id="includePMI"
                                        v-model="IsPmiInclude"
                                        type="checkbox"
                                    />
                                    <label for="includePMI"> Include PMI</label>
                                    <lt-label
                                        :span="span"
                                        :tooltip-link="PrivateMortgageInsuranceTooltip"
                                    />
                                </div>
                            </div>
                            <div>
                                <a
                                    href="javascript:void(0)"
                                    class="reset-calc hidden-xs"
                                    @click="resetFilters()"><span class="lt-icons lt4-Refresh"></span> Reset Calculator</a>
                            </div>
                        </div>
                    </div>
                </transition>
                <!-- Advanced Options end-->
                <div class="controls">
                    <button
                        type="button"
                        class="show-hide-options"
                        @click="viewMoreClick()">
                        <span
                            class="lt-icons"
                            :class="{ 'lt4-MinusCircle': ShowAdvancedOptions, 'lt4-PlusCircle' : !ShowAdvancedOptions}"></span>
                        {{ ShowAdvancedOptions ? "Hide" : "Show" }}
                        Advanced Options
                    </button>
                    <div>
                        <advertising-disclosures
                            :disclosure-id="DisclosureId"
                            :disclosure-text="DisclosureText"
                            :disclosure-tokens="DisclosureTokens"
                        />
                    </div>
                </div>
            </div>
            <button
                class="main-btn btn-green"
                type="submit"
                @click="redirect()">
                <div class="home-worth text-center">
                    <span>You can afford a house worth</span>
                    <span class="home-price">${{ currencyFilter(CalculatedValues.homeprice) }}</span>
                    <span>View offers today</span>
                </div>
                <div class="button-arrow">
                    <span class="lt4-ChevronRight"></span>
                </div>
            </button>
            <div class="calculation-section">
                <div class="left-section">
                    <h3>Adjust your price range</h3>
                    <p>See how your budget changes based on your affordability range</p>
                    <div class="house-image">
                        <transition name="fade">
                            <img
                                v-if="percent < 20"
                                src="../../assets/images/house1.svg"
                                alt="Conservative home affordability range - small house"
                            />
                        </transition>
                        <transition name="fade">
                            <img
                                v-if="percent >= 20 && percent < 40"
                                src="../../assets/images/house2.svg"
                                alt="Low-moderate home affordability range - medium house"
                            />
                        </transition>
                        <transition name="fade">
                            <img
                                v-if="percent >= 40 && percent < 60"
                                src="../../assets/images/house3.svg"
                                alt="Moderate home affordability range - larger house"
                            />
                        </transition>
                        <transition name="fade">
                            <img
                                v-if="percent >= 60 && percent < 80"
                                src="../../assets/images/house4.svg"
                                alt="High home affordability range - large house"
                            />
                        </transition>
                        <transition name="fade">
                            <img
                                v-if="percent >= 80"
                                src="../../assets/images/house5.svg"
                                alt="Aggressive home affordability range - luxury house"
                            />
                        </transition>
                    </div>
                    <!-- Range Slider start-->
                    <div class="slider-parent">
                        <vue-slider
                            ref="vueSlider"
                            v-model="slider.value"
                            :bg-style="slider.bgStyle"
                            :clickable="slider.clickable"
                            :dot-size="slider.dotSize"
                            :height="slider.height"
                            :max="slider.max"
                            :min="slider.min"
                            :process-style="slider.processStyle"
                            :slider-style="slider.sliderStyle"
                            :tooltip="slider.tooltip"
                            @callback="handleSliderChange($event);"
                        />
                        <div class="range-label">
                            <div class="text-left">
                                <label>Conservative</label>
                            </div>
                            <div class="text-right">
                                <label>Aggressive</label>
                            </div>
                        </div>
                    </div>
                    <!-- Range Slider end-->
                    <label
                        v-show="HomePriceMsg"
                        class="DTI-exceeded">Your current Debt to income ratio has already exceeded {{ DebtToIncome }}%</label>
                    <div class="calc-box">
                        <div class="calc-box-section">
                            <h3 class="value">
                                ${{ currencyFilter(CalculatedValues.homeprice) }}
                            </h3>
                            <label>Home Price</label>
                        </div>
                        <div class="calc-box-section">
                            <h3 class="value">
                                ${{ currencyFilter(CalculatedPayment) }}
                            </h3>
                            <label>Monthly Payment</label>
                        </div>
                        <div class="calc-box-section">
                            <h3
                                ref="debtRatio"
                                class="value">
                                {{ DebtToIncome }}% <lt-label
                                    :span="span"
                                    :tooltip-link="DebtToIncomeRatioDtiTooltip"
                                />
                            </h3>
                            <label>Debt to Income</label>
                        </div>
                    </div>
                    <div class="view-free-offers desktop">
                        <button
                            type="submit"
                            class="btn btn-blue"
                            @click="redirect()">
                            {{ DestinationButtonText }}
                        </button>
                    </div>
                    <lt-logo v-if="ltLogo==1">
                        <small>NMLS#1136 Terms & Conditions Apply</small>
                    </lt-logo>
                </div>
                <div class="right-section text-center">
                    <h3>Monthly budget breakdown</h3>
                    <p>Detailed view of your ${{ currencyFilter(CalculatedValues.income) }} monthly budget</p>
                    <div class="chart-parent">
                        <doughnut-chart
                            ref="doughnutChart"
                            type="RoundedDoughnut"
                            :chart-data="chartData"
                            :options="options"
                            :width="chartWidth"
                            :height="chartHeight"
                        />
                    </div>
                    <div class="summary">
                        <div>
                            <label><span class="green-bg"></span>Mo. Mortgage PMNT</label>
                            <span class="value">${{ currencyFilter(CalculatedPayment) }}</span>
                        </div>
                        <div>
                            <label><span class="deep-verde-bg"></span>Debt Payments</label>
                            <span class="value">${{ currencyFilter(CalculatedValues.debts) }}</span>
                        </div>
                        <div>
                            <label><span class="blue-bg"></span>Income Taxes</label>
                            <span class="value">${{ currencyFilter(CalculatedValues.taxes) }}</span>
                        </div>
                        <div>
                            <label><span class="purple-bg"></span>Left Over</label>
                            <span class="value">${{ currencyFilter(CalculatedValues.leftover) }}</span>
                        </div>
                    </div>
                    <div class="view-free-offers mobile">
                        <button
                            type="submit"
                            class="btn btn-blue"
                            @click="redirect()">
                            {{ DestinationButtonText }}
                        </button>
                    </div>
                </div>
                <div class="about-calculator text-center">
                    <p class="sub-heading">
                        Our home affordability calculator helps you understand how much home you can afford based on your income and other debts.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import VueSlider from 'vue-slider-component';
    import DoughnutChart from '~/components/v2/doughnut-chart.vue';
    import LtLabel from '~/components/v2/lt-label.vue';
    import LtLogo from '~/components/lt-logo.vue';
    import LoanTermList from '~/constants/v2/loan-term-list';
    import DefaultTooltip from '~/constants/v2/tooltip-defaults';
    import ChartTooltip from '~/helpers/chart-tooltip';
    import CalculatorHelper from '~/helpers/v2/payment';
    import BaseMixin from '~/mixin/v2/base-mixin';
    import TokenService from '~/services/token';

    export default {
        components: {
            LtLabel,
            VueSlider,
            LtLogo,
            DoughnutChart,
        },
        mixins: [BaseMixin],
        props: {
            labelAnnualIncome: {
                default: 'Annual Income',
            },
            labelMonthlyExpenses: {
                default: 'Monthly Debt',
            },
            labelDownPayment: {
                default: 'Down Payment',
            },
            labelEstCreditScore: {
                default: 'Est. Credit Score',
            },
            customizeButtonText: {
                default: 'Customize',
            },
            labelLoanType: {
                default: 'Loan Type',
            },
            labelLoanTerm: {
                default: 'Loan Term',
            },
            labelMortgageRate: {
                default: 'Mortgage Rate',
            },
            labelPropertyTaxes: {
                default: 'Annual Property Taxes',
            },
            labelHomeInsurance: {
                default: 'Annual Home Insurance',
            },
            labelHoaFees: {
                default: 'HOA Fees',
            },
            labelMonthlyHoaFees: {
                default: 'Monthly HOA Fees',
            },
            annualIncome: {
                default: '65000',
            },
            monthlyExpenses: {
                default: '0',
            },
            downPayment: {
                default: '59500',
            },
            mortgageRate: {
                default: '2.25',
            },
            mortgageRateToken: {
                default: '30_FIXED_RATE_350K',
            },
            propertyTaxes: {
                default: '1.2',
            },
            propertyTaxesval: {
                default: '3,640',
            },
            homeInsurance: {
                default: '800',
            },
            hoaFees: {
                default: '0',
            },
            creditScore: {
                default: '2',
            },
            loanTermInYears: {
                default: '30',
            },
            downPaymentTooltip: {
                default: DefaultTooltip.DownPayment,
            },
            loanTypeTooltip: {
                default: DefaultTooltip.LoanType,
            },
            monthlyExpensesTooltip: {
                default: DefaultTooltip.MonthlyExpenses,
            },
            annualIncomeTooltip: {
                default: DefaultTooltip.AnnualIncome,
            },
            privateMortgageInsuranceTooltip: {
                default: DefaultTooltip.PrivateMortgageInsurance,
            },
            debtToIncomeRatioDtiTooltip: {
                default: DefaultTooltip.DebtToIncomeRatioDti,
            },
            showAdvancedOptions: {
                default: false,
            },
            span: {
                type: String,
                default: '',
            },
            recalculateButtonText: {
                default: 'Recalculate',
            },
            zipCode: {
                default: 28277,
            },
            debtToIncome: {
                default: 28,
            },
            ltLogo: {
                default: 0,
            },
            disclosureTokens: {
                default: '1,95',
            },
            disclosureId: {
                default: 'Disclosure01',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            destinationLinkOrId: {
                default: 'wp-mortgage',
            },
            destinationButtonText: {
                default: 'View Free Offers',
            },
            header: {
                default: '',
            },
            subheader: {
                default: '',
            },
            myltexp: {
                default: '0',
            },
            showTooltipLoader: {
                default: false,
            },
        },
        data() {
            return {
                hasHeader: false,
                hasSubheader: false,
                AnnualIncome: this.annualIncome,
                MonthlyExpenses: this.monthlyExpenses,
                DownPayment: this.downPayment,
                MortgageRate: this.mortgageRate,
                MortgageRateToken: this.mortgageRateToken,
                PropertyTaxes: this.propertyTaxes,
                PropertyTaxesVal: this.propertyTaxesval,
                HomeInsurance: this.homeInsurance,
                HoaFees: this.hoaFees,
                LoanTermInYears: this.loanTermInYears,
                LoanTermInYearsList: LoanTermList.LoanTermInYearsList.refinance,
                DownPaymentTooltip: parseInt(this.hideTooltip, 10) ? '' : this.downPaymentTooltip,
                AnnualIncomeTooltip: parseInt(this.hideTooltip, 10) ? '' : this.annualIncomeTooltip,
                MonthlyExpensesTooltip: parseInt(this.hideTooltip, 10) ? '' : this.monthlyExpensesTooltip,
                LoanTypeTooltip: parseInt(this.hideTooltip, 10) ? '' : this.loanTypeTooltip,
                PrivateMortgageInsuranceTooltip: parseInt(this.hideTooltip, 10) ? '' : this.privateMortgageInsuranceTooltip,
                DebtToIncomeRatioDtiTooltip: parseInt(this.hideTooltip, 10) ? '' : this.debtToIncomeRatioDtiTooltip,
                ShowAdvancedOptions: this.showAdvancedOptions,
                IsPmiInclude: false,
                DebtToIncome: this.debtToIncome,
                CalculatedValues: {},
                DownpaymentPercentage: '19',
                DisclosureId: this.disclosureId,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,

                // Chart data
                chartData: {
                    labels: [],
                    datasets: [{
                        data: [28, 0, 30, 42],
                        backgroundColor: [
                            '#08c177',
                            '#078181',
                            '#00aeef',
                            '#800080',
                        ],
                        borderWidth: 0,
                    }],
                },
                options: {
                    cutoutPercentage: 85,
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        enabled: false,
                        custom: ChartTooltip.customTooltips,
                    },
                },
                chartWidth: this.myltexp === '1' ? 120 : 200,
                chartHeight: this.myltexp === '1' ? 50 : 130,
                // Setting for range slider
                slider: {
                    value: Math.max(15, Math.min(50, this.debtToIncome)),
                    height: 10,
                    sliderStyle: {
                        backgroundColor: '#00aeef',
                    },
                    bgStyle: {
                        background: 'linear-gradient(90deg, #08c177 28%, #ffc507 51%, #ff704d 79%, #d93551)',
                    },
                    processStyle: {
                        backgroundColor: 'transparent',
                    },
                    dotSize: 25,
                    tooltip: false,
                    clickable: true,
                    max: 50,
                    min: 15,
                },
            };
        },
        computed: {
            postData() {
                return {
                    annualIncome: this.unformatFigure(this.AnnualIncome),
                    monthlyExpenses: this.unformatFigure(this.MonthlyExpenses),
                    loanterm: this.LoanTermInYears,
                    estimatedDownPayment: this.unformatFigure(this.DownPayment),
                    hoa: this.unformatFigure(this.HoaFees),
                    homeInsurance: this.unformatFigure(this.HomeInsurance),
                    mortgageRate: this.MortgageRate,
                    propertyTaxes: this.PropertyTaxes,
                    propertyTaxesval: this.unformatFigure(this.PropertyTaxesVal),
                    pmi: this.IsPmiInclude,
                    debtToIncome: this.DebtToIncome,
                };
            },

            percent() {
                return (this.DebtToIncome - this.slider.min) / (this.slider.max - this.slider.min) * 100;
            },

            CalculatedPayment() {
                return this.IsPmiInclude ? this.CalculatedValues.payment + this.CalculatedValues.pmi : this.CalculatedValues.payment;
            },

            chartLabels() {
                return [
                    `Monthly Mortgage Payment $${this.CalculatedPayment}`,
                    `Debt Payments $${this.CalculatedValues.debts}`,
                    `Income Taxes $${this.CalculatedValues.taxes}`,
                    `Left Over $${this.CalculatedValues.leftover}`,
                ];
            },

            chartDataValues() {
                const paymentPercent = Math.round(this.CalculatedPayment / this.CalculatedValues.income * 100);
                const debtPercent = Math.round(this.CalculatedValues.debts / this.CalculatedValues.income * 100);
                const taxesPercent = Math.round(this.CalculatedValues.taxes / this.CalculatedValues.income * 100);
                const leftoverPercent = Math.round(this.CalculatedValues.leftover / this.CalculatedValues.income * 100);
                return [paymentPercent, debtPercent, taxesPercent, leftoverPercent];
            },

            HomePriceMsg() {
                // eslint-disable-next-line eqeqeq
                return !!(this.CalculatedValues.homeprice == 0 || typeof this.CalculatedValues.homeprice == 'string' || isNaN(this.CalculatedValues.homeprice));
            },
        },
        watch: {
            // Watch multiple properties that trigger rate calculation
            postData: {
                handler() {
                    this.calcualteRates();
                },
                deep: true,
            },
            IsPmiInclude() {
                this.calcualteRates(true);
            },
        },
        mounted() {
            this.handleSliderChange(this.debtToIncome);
            this.hasHeader = this.header !== '';
            this.hasSubheader = this.subheader !== '';
        },
        methods: {
            viewMoreClick() {
                this.ShowAdvancedOptions = !this.ShowAdvancedOptions;
            },

            handleSliderChange(barValue) {
                this.DebtToIncome = barValue;
                this.updateDebtRatioColor();
                TokenService.GetTokenValue(this.MortgageRateToken, (rate) => {
                    this.updateMortgageRate(rate);
                });
            },

            calcualteRates(IsPmiIncludeChanged = false) {
                this.calculateDownPaymentPer(IsPmiIncludeChanged);

                this.CalculatedValues = CalculatorHelper.calculateHomeRates(this.postData, 'calculate');
                this.PropertyTaxesVal = CalculatorHelper.calculateHomeRates(this.postData, 'calculatePropertyTaxval');

                this.updateChartData();
                this.fireChangeEvent();
            },
            currencyFilter(figure) {
                return Accounting.formatNumber(figure);
            },
            resetFilters() {
                this.AnnualIncome = this.formatFigure(this.annualIncome);
                this.MonthlyExpenses = this.formatFigure(this.monthlyExpenses);
                this.DownPayment = this.formatFigure(this.downPayment);
                this.MortgageRate = this.mortgageRate;
                this.PropertyTaxes = parseFloat(this.propertyTaxes).toFixed(2);
                this.PropertyTaxesVal = this.formatFigure(this.propertyTaxesval);
                this.HomeInsurance = this.formatFigure(this.homeInsurance);
                this.HoaFees = this.formatFigure(this.hoaFees);
                this.LoanTermInYears = this.loanTermInYears;
                this.LoanTermInYearsList = LoanTermList.LoanTermInYearsList.refinance;
                this.IsPmiInclude = false;
                this.DownpaymentPercentage = '19';

                // Reset slider using Vue refs and component API
                this.resetSliderPosition();
                this.handleSliderChange(this.debtToIncome);
            },
            calculateDownPaymentPer(IsPmiIncludeChanged = false) {
                this.DownpaymentPercentage = CalculatorHelper.calculateHomeRates(this.postData, 'calculateDownpayment');

                if (!IsPmiIncludeChanged && this.DownpaymentPercentage <= 20) {
                    this.IsPmiInclude = true;
                }
            },
            calculatePropertyvalue() {
                this.PropertyTaxesVal = CalculatorHelper.calculateHomeRates(this.postData, 'calculatePropertyTaxval');
            },

            updateMortgageRate(rate) {
                this.MortgageRate = rate || this.mortgageRate;
            },
            updateChartData() {
                this.chartData.labels = [...this.chartLabels];
                this.chartData.datasets[0].data = [...this.chartDataValues];
                this.$refs.doughnutChart.update();
            },
            fireChangeEvent() {
                this.$el.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: {
                    type: 'lendingtree.mortgageui.yantr',
                    action: 'home-affordability-data',
                    params: {
                        annualIncome: this.AnnualIncome,
                        monthlyDebt: this.MonthlyExpenses,
                        downPayment: this.DownPayment,
                        loanTermInYears: this.LoanTermInYears,
                        affordableHomePrice: this.CalculatedValues.homeprice,
                    },
                } }));
            },
            updateDebtRatioColor() {
                const element = this.$refs.debtRatio;
                if (!element) return;

                element.style.color = this.percent < 45
                    ? '#08c177'
                    : this.percent < 60
                        ? '#ffc507'
                        : this.percent < 79
                            ? '#ff704d'
                            : '#d93551';
            },

            resetSliderPosition() {
                const slider = this.$refs.vueSlider;
                if (!slider) return;

                slider.setValue(Math.max(15, Math.min(50, this.debtToIncome)));
                slider.refresh();
            },
        },
    };

</script>
<style src="../../assets/styles/v2/common.scss" lang="scss"></style>
<style src="../../assets/styles/v2/calc-advanced-filter.scss" lang="scss"></style>
<style src="../../assets/styles/v2/mylt-dashboard-calculator.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
